export default __webpack_public_path__ + "static/media/unej.f2a5a41f.png";